<script>
  import Page from '@components/page'
  import Form from '@components/forms'
  import ProgrammeFormFields from '@components/programmes/form-fields.svelte'
  import Button from '@components/buttons/button.svelte'
  import { useForm, router } from '@inertiajs/svelte'
  import { Save, Trash2, BookOpen, ChevronLeft } from 'lucide-svelte'

  let { programme } = $props()

  const form = useForm({
    name: programme?.name || '',
    key: programme?.key || '',
    starts_on: programme?.starts_on || '',
    ends_on: programme?.ends_on || '',
    description: programme?.description?.html || '',
  })

  const deleteForm = useForm({})

  function handleSubmit(e) {
    e.preventDefault()
    $form.transform(data => ({ programme: data }))
    $form.put(`/admin/programmes/${programme.id}`, {
      onSuccess: () => router.visit('/admin/programmes'),
    })
  }

  function handleDelete() {
    if (!window.confirm(`Are you sure you want to delete ${programme.name}?`)) return
    $deleteForm.delete(`/admin/programmes/${programme.id}`, {
      onSuccess: () => router.visit('/admin/programmes'),
    })
  }

  let navigationProps = {
    title: programme?.name || "Edit programme",
    Icon: BookOpen,
    links: [{ text: "Admin", href: "/admin" }, { text: "Programmes", href: "/admin/programmes" }],
  }
</script>

<Page.Layout title={programme?.name || "Edit programme"}>

  <Page.Navigation {...navigationProps} />

  <Page.Titles title={programme?.name || "Edit programme"} subtitle="Edit this programme">
    {#snippet buttons()}
      <Button text="Back" path="/admin/programmes" BeforeIcon={ChevronLeft} />
      <Button variant="warning" text="Delete" Icon={Trash2} onclick={handleDelete} loading={$deleteForm.processing} />
      <Button type="submit" form="programme-form" text="Update" variant="submit" Icon={Save} loading={$form.processing} />
    {/snippet}
  </Page.Titles>

  <Form.Element {form} id="programme-form" onsubmit={handleSubmit}>
    <ProgrammeFormFields {form} {programme} />
  </Form.Element>

</Page.Layout>
